import { render, staticRenderFns } from "./VASBlock.vue?vue&type=template&id=4af3fad2&lang=pug&"
import script from "./VASBlock.vue?vue&type=script&lang=js&"
export * from "./VASBlock.vue?vue&type=script&lang=js&"
import style0 from "./VASBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports